import { PropertyType } from "../../../../../types/constants";

import { ReactComponent as HouseIcon } from "../../../../../assets/icons/property-type/house.svg";
import { ReactComponent as CondosAndTownhomesIcon } from "../../../../../assets/icons/property-type/condos-and-townhomes.svg";
import { ReactComponent as MultiFamilyIcon } from "../../../../../assets/icons/property-type/multi-family.svg";
import { ReactComponent as CommercialIcon } from "../../../../../assets/icons/property-type/commercial.svg";
import { ReactComponent as LandIcon } from "../../../../../assets/icons/property-type/land.svg";
import { ReactComponent as RanchIcon } from "../../../../../assets/icons/property-type/ranch.svg";

import styles from "./PropertyTypeOption.module.scss";
import CheckboxGroup from "../../../../search-filter-options/CheckboxGroup/CheckboxGroup";

interface PropertyTypeOptionProps {
  value: PropertyType[];
  onChange: (values: string[]) => void;
  className?: string;
}

export default function PropertyTypeOption({
  value,
  onChange,
  className,
}: PropertyTypeOptionProps) {
  return (
    <CheckboxGroup
      label="Select Property Type"
      name="property-types"
      value={value}
      className={className}
      options={[
        {
          label: "Homes",
          value: PropertyType.Homes,
          icon: <HouseIcon className={styles.icon} />,
          buttonName: "Homes",
        },
        {
          label: "Condos & Townhomes",
          value: PropertyType.CondosAndTownhomes,
          icon: <CondosAndTownhomesIcon className={styles.icon} />,
          buttonName: "Condos and townhomes",
        },
        {
          label: "Multi-family",
          value: PropertyType.MultiFamily,
          icon: <MultiFamilyIcon className={styles.icon} />,
          buttonName: "Multi family",
        },
        {
          label: "Commercial",
          value: PropertyType.Commercial,
          icon: <CommercialIcon className={styles.icon} />,
          buttonName: "Commercial",
        },
        {
          label: "Land",
          value: PropertyType.Land,
          icon: <LandIcon className={styles.icon} />,
          buttonName: "Land",
        },
        {
          label: "Ranch",
          value: PropertyType.Ranch,
          icon: <RanchIcon className={styles.icon} />,
          buttonName: "Ranch",
        },
      ]}
      onChange={onChange}
    />
  );
}
